/* src/app/components/home-popover/home-popover.component.scss */
ion-chip {
  border-radius: 0;
  background: #F5F5F5;
  font-weight: bold;
  justify-content: center;
  color: var(--ion-color-main);
  transition: 200ms linear;
  flex: 1;
  margin: 0;
  text-align: center;
}
ion-chip.selected {
  background: var(--ion-color-second);
  color: #fff;
  transition: 200ms linear;
  margin-left: 10px;
  flex: 1;
}
.address-popover {
  padding: 20px;
  background: #fff;
  font-family: AppFont-black, sans-serif;
}
/*# sourceMappingURL=home-popover.component.css.map */
